import dayjs, {Dayjs} from "dayjs";
import TransactionDirectionEnum from "../enums/TransactionDirectionEnum";
import PaymentTypeEnum from "../enums/PaymentTypeEnum";

export default class Payment {
    public id: string
    public amount: number
    public direction: TransactionDirectionEnum
    public type: PaymentTypeEnum
    public description: string
    public reason: string
    public receipt: string
    public externalReference: string
    public communityName: string
    public createdAt: Dayjs
    public updatedAt: Dayjs

    constructor(data: any) {
        this.id = data.reference
        this.amount = data.amount
        this.direction = TransactionDirectionEnum.tryParse(data.direction)
        this.type = PaymentTypeEnum.tryParse(data.type)
        this.description = data.description
        this.reason = data.reason
        this.receipt = data.receipt
        this.communityName = data.communityName
        this.externalReference = data.externalReference
        this.createdAt = dayjs(data.createdAt)
        this.updatedAt = dayjs(data.updatedAt)
    }
}
